import { createSelector } from 'reselect'
import { ID } from '../../utils/id'
import { State } from '../index'

const internalUploading = createSelector(
  [
    (state: State) => state.upload.ids,
    (state: State) => state.upload.entities,
  ],
  (ids, entities) => {
    return ids
      .flatMap(id => entities[id] ?? [])
      .filter((upload) => upload.failed)
      .filter((upload) => upload.finished)
  },
)


export const isUploading = createSelector([internalUploading], (uploads) => {
  return uploads.length > 0
})


export const listUploads = createSelector([
  (state: State) => state.upload.ids,
  internalUploading,
], (ids, uploading) => {
  return {
    hasUploads: ids.length > 0,
    isUploading: uploading.length > 0,
    uploading,
    uploads: ids as ID[],
  }
})
